import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4be69838"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qr-code-wrapper" }

import QRCodeStyling, { Options } from 'qr-code-styling';
import { onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QrCodeComp',
  props: {
    value: {},
    logoUrl: {},
    width: {},
    height: {},
    showLogo: { type: Boolean }
  },
  emits: ["qr-ready"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const qrCodeRef = ref<HTMLElement | null>(null);
const validLogoUrl = ref<string | undefined>();
const imageSizePercent = ref(0.4);

const width = props.width || 16;
const height = props.height || 160;

const qrInstance = new QRCodeStyling({
  width,
  height,
  type: 'canvas',
  data: props.value,
  margin: 0,
  qrOptions: {
    typeNumber: 0,
    mode: 'Byte',
    errorCorrectionLevel: 'Q',
  },
  imageOptions: {
    hideBackgroundDots: true,
    imageSize: imageSizePercent.value,
    margin: 0,
    crossOrigin: 'anonymous',
    saveAsBlob: true,
  },
  dotsOptions: {
    type: 'dots',
    color: '#6a1a4c',
    roundSize: true,
    gradient: {
      type: 'linear',
      rotation: 0,
      colorStops: [
        { offset: 0, color: '#121112' },
        { offset: 1, color: '#0c0c0d' },
      ],
    },
  },
  backgroundOptions: {
    color: '#ffffff',
    round: 0,
  },
  cornersSquareOptions: {
    type: 'extra-rounded',
    color: '#000000',
  },
  cornersDotOptions: {
    type: undefined,
    color: '#000000',
  },
});

function clearAndRender() {
  if (!qrCodeRef.value) return;
  qrCodeRef.value.innerHTML = '';
  qrInstance.append(qrCodeRef.value);
  emit('qr-ready');
}

function updateQRCode() {
  const hasLogo = props.showLogo && validLogoUrl.value;

  const updateOptions: Partial<Options> = {
    data: props.value,
  };

  if (hasLogo) {
    updateOptions.image = validLogoUrl.value;
    updateOptions.imageOptions = {
      hideBackgroundDots: true,
      margin: 0,
      imageSize: imageSizePercent.value,
      crossOrigin: 'anonymous',
      saveAsBlob: true,
    };
  }

  qrInstance.update(updateOptions);
  emit('qr-ready');
}

function validateImage(url: string): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const maxPx = Math.min(width, height) * 0.4;
      const longest = Math.max(img.width, img.height);
      imageSizePercent.value = longest > maxPx ? maxPx / longest : 0.4;
      resolve(true);
    };
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

watch(
  () => props.logoUrl,
  async (url) => {
    validLogoUrl.value = undefined;
    if (props.showLogo && url && (await validateImage(url))) {
      validLogoUrl.value = url;
    }
    updateQRCode();
  },
  { immediate: true },
);

watch(() => props.value, updateQRCode);

onMounted(() => {
  clearAndRender();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "qrCodeRef",
      ref: qrCodeRef
    }, null, 512)
  ]))
}
}

})